"use strict";
exports.__esModule = true;
exports.useMapboxToken = exports.useMapboxTokenStrict = exports.enrichMapboxToken = exports.withMapboxToken = exports.MapboxTokenProvider = exports.MapboxTokenContext = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * @alpha
 */
exports.MapboxTokenContext = react_1["default"].createContext({
    mapboxToken: undefined
});
/**
 * @alpha
 */
exports.MapboxTokenProvider = function (_a) {
    var token = _a.token, children = _a.children;
    return (react_1["default"].createElement(exports.MapboxTokenContext.Provider, { value: { mapboxToken: token } }, children));
};
/**
 * @internal
 */
function withMapboxToken(InnerComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            tslib_1.__extends(MapboxTokenHOC, _super);
            function MapboxTokenHOC() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            MapboxTokenHOC.prototype.render = function () {
                var mapboxToken = this.context.mapboxToken;
                var props = this.props;
                return (react_1["default"].createElement(react_1["default"].Fragment, null,
                    react_1["default"].createElement(InnerComponent, tslib_1.__assign({}, props, { config: enrichMapboxToken(props.config, mapboxToken) }))));
            };
            return MapboxTokenHOC;
        }(react_1["default"].Component)),
        _a.contextType = exports.MapboxTokenContext,
        _a;
}
exports.withMapboxToken = withMapboxToken;
/**
 * @internal
 */
function enrichMapboxToken(config, mapboxToken) {
    return mapboxToken
        ? tslib_1.__assign(tslib_1.__assign({}, (config || {})), { mapboxToken: (config === null || config === void 0 ? void 0 : config.mapboxToken) || mapboxToken })
        : config;
}
exports.enrichMapboxToken = enrichMapboxToken;
/**
 * @alpha
 */
function useMapboxTokenStrict(mapboxToken) {
    var context = react_1.useContext(exports.MapboxTokenContext);
    var token = mapboxToken !== null && mapboxToken !== void 0 ? mapboxToken : context.mapboxToken;
    ts_invariant_1["default"](token, "Mapbox token was not provided. Use <MapboxTokenProvider /> to provide token.");
    return token;
}
exports.useMapboxTokenStrict = useMapboxTokenStrict;
/**
 * @alpha
 */
function useMapboxToken(mapboxToken) {
    var context = react_1.useContext(exports.MapboxTokenContext);
    return mapboxToken !== null && mapboxToken !== void 0 ? mapboxToken : context.mapboxToken;
}
exports.useMapboxToken = useMapboxToken;
//# sourceMappingURL=MapboxTokenProvider.js.map